import React from 'react';
import PropTypes from 'prop-types';
import { updateCardInventory } from '../api/cards';
import { getCardImageSrc, handleCardImageError } from '../hooks/useCardImage';
import { cardShape } from '../propTypes/cardPropTypes';

const CardBacksPicker = ({ card, cardInventory, variants, onCardInventoryUpdated }) => {
    const canShow = !!card && !card.customImage && Array.isArray(variants) && variants.length > 1;
    if (!canShow || !cardInventory) return null;

    const handleVariantClick = async variant => {
        try {
            const result = await updateCardInventory(cardInventory.inventoryID, variant);
            const updatedInventory = result?.cardInventory || result?.inventory || result;
            if (!updatedInventory || typeof updatedInventory !== 'object' || Array.isArray(updatedInventory)) return;

            onCardInventoryUpdated?.({
                ...(cardInventory || {}),
                ...(updatedInventory || {}),
                displayKey: variant,
            });
        } catch (error) {
            console.error('Error updating variant:', error);
        }
    };

    return (
        <>
            <h3>Available Backs</h3>
            <div className="card-variants-page">
                {variants.map(variant => (
                    <button
                        key={variant}
                        type="button"
                        className={`variant-container ${variant === cardInventory.displayKey ? 'active' : ''}`}
                        onClick={() => handleVariantClick(variant)}
                        aria-pressed={variant === cardInventory.displayKey}
                    >
                        <img src={getCardImageSrc(variant)} alt={variant} className="variant-image" onError={handleCardImageError} />
                    </button>
                ))}
            </div>
        </>
    );
};

CardBacksPicker.propTypes = {
    card: cardShape,
    cardInventory: PropTypes.shape({
        inventoryID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        displayKey: PropTypes.string,
    }),
    variants: PropTypes.arrayOf(PropTypes.string),
    onCardInventoryUpdated: PropTypes.func,
};

export default CardBacksPicker;
